import { createContext, useContext, useReducer } from 'react';
import { ACTION_TYPES, LoginReducer, LoginState } from './login-reducer';


const LoginContext = createContext<LoginState | undefined>(undefined);
const LoginContextDispatchContext = createContext({} as any);

const LoginProvider = ({ children }: { children: React.ReactNode }) => {
    const [state, dispatch] = useReducer(LoginReducer, { step: 1, fieldIsValid: true, preAuthenticationRequest: { type: 1 } } as LoginState);

    return (
        <LoginContext.Provider value={state}>
            <LoginContextDispatchContext.Provider value={dispatch}>
                {children}
            </LoginContextDispatchContext.Provider>
        </LoginContext.Provider>
    );
}

const useLoginState = () => {
    const context = useContext(LoginContext);
    if (context === undefined) {
        throw new Error('useLoginState must be used within a HomeProvider');
    }
    return context;
}

const useLoginDispatch = () => {
    const context = useContext(LoginContextDispatchContext);
    if (context === undefined) {
        throw new Error('useLoginDispatch must be used within a HomeProvider');
    }
    return context;
}

export { LoginProvider, useLoginDispatch, useLoginState, ACTION_TYPES };
